'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _nationalityLabels = require('./nationality/nationalityLabels');

var _nationalityLabels2 = _interopRequireDefault(_nationalityLabels);

var _nationalityValues = require('./nationality/nationalityValues');

var _nationalityValues2 = _interopRequireDefault(_nationalityValues);

var _genderLabels = require('./gender/genderLabels');

var _genderLabels2 = _interopRequireDefault(_genderLabels);

var _genderValues = require('./gender/genderValues');

var _genderValues2 = _interopRequireDefault(_genderValues);

var _monthLabels = require('./month/monthLabels');

var _monthLabels2 = _interopRequireDefault(_monthLabels);

var _monthValues = require('./month/monthValues');

var _monthValues2 = _interopRequireDefault(_monthValues);

var _bedTypeLabels = require('./bed_type/bedTypeLabels');

var _bedTypeLabels2 = _interopRequireDefault(_bedTypeLabels);

var _bedTypeValues = require('./bed_type/bedTypeValues');

var _bedTypeValues2 = _interopRequireDefault(_bedTypeValues);

var _bedTypeDescriptions = require('./bed_type/bedTypeDescriptions');

var _bedTypeDescriptions2 = _interopRequireDefault(_bedTypeDescriptions);

var _bootsSizeLabels = require('./boots_size/bootsSizeLabels');

var _bootsSizeLabels2 = _interopRequireDefault(_bootsSizeLabels);

var _bootsSizeValues = require('./boots_size/bootsSizeValues');

var _bootsSizeValues2 = _interopRequireDefault(_bootsSizeValues);

var _jacketSizeLabels = require('./jacketSize/jacketSizeLabels');

var _jacketSizeLabels2 = _interopRequireDefault(_jacketSizeLabels);

var _jacketSizeValues = require('./jacketSize/jacketSizeValues');

var _jacketSizeValues2 = _interopRequireDefault(_jacketSizeValues);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formOptions = {
    nationalityLabels: _nationalityLabels2.default,
    nationalityValues: _nationalityValues2.default,
    genderLabels: _genderLabels2.default,
    genderValues: _genderValues2.default,
    monthLabels: _monthLabels2.default,
    monthValues: _monthValues2.default,
    bedTypeLabels: _bedTypeLabels2.default,
    bedTypeValues: _bedTypeValues2.default,
    bedTypeDescriptions: _bedTypeDescriptions2.default,
    bootsSizeLabels: _bootsSizeLabels2.default,
    bootsSizeValues: _bootsSizeValues2.default,
    jacketSizeLabels: _jacketSizeLabels2.default,
    jacketSizeValues: _jacketSizeValues2.default
}; /**
   *  Point of contact for form input option labels/values
   *
   *  ie: import { nationalities } from 'metadata/formOptions';
   *
   *  Labels are in MessageDescriptorMap format for react-intl:
   *
   *    type MessageDescriptor = {
   *        id: string,
   *        defaultMessage: string,
   *        description?: string,
   *    };
   *
   *    type MessageDescriptorMap = {[key: string]: MessageDescriptor};)
   */

exports.default = formOptions;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/metadata/forms/formOptions/index.js
// module id = 1372
// module chunks = 0